// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MesTable {\n  height: 100%;\n}\n.MesTable .pagination-warp {\n  padding: 10px 0;\n}\n.first-col {\n  display: inline-block;\n}\n.first-col-bottom {\n  position: absolute;\n  bottom: 0px;\n  left: 10px;\n  right: 10px;\n  padding-bottom: 20px;\n}\n.first-col-content {\n  display: inline-block;\n  height: 20px;\n  line-height: 20px;\n}", ""]);
// Exports
module.exports = exports;
